import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./index.scss";
import Sectionfive from "./Sectionfive";
import Sectiontwo from "./Sectiontwo";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Aos from "aos";
function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div className="AboutPage">
      <Helmet>
        <link rel="canonical" href="https://www.ggilab.com/About" />
        <title>Galaxy Gemological Institute -Unveiling Our Expertise and Mission</title>
        <meta
          name="description"
          content="Discover the world of Galaxy Gemological Institute – leaders in gemology education. Explore our mission, dedicated team, and passion for gem knowledge."
        />
      </Helmet>
      <div className="AboutSec">
        <div className="container innerAboutSec">
          <div className="layer">
            <div className="titleDiv margintb">
              <h1 className="title" data-aos="fade-up">
                <span className="GGIFont"> Galaxy Gemological Institute </span>
              </h1>
              <h2 className="title" data-aos="fade-up"> <span className="GGIFont">
                A Legacy of Excellence</span>
              </h2>
              <p data-aos="fade-down">
            Established in 2013, the Galaxy Gemological Institute (GGI) 
            is a leading gemological institution committed to providing
            comprehensive services in gemstone testing, education, and
            certification. With headquarters in the heart of Karachi's
            vibrant gem and jewelry market, Saddar, and a branch in Peshawar's bustling Namak Mandi, 
            GGI is strategically positioned to serve the entire nation.</p>
            <p data-aos="fade-down">
             As a pioneer in the industry, GGI was the first gemstone testing laboratory in
            Pakistan to offer online verification, revolutionizing the way gemstones are
           authenticated. Our internationally recognized diamond grading reports are
           trusted by clients worldwide, solidifying our position as the best diamond 
            testing laboratory in Pakistan.</p>
            <p data-aos="fade-down">
            Beyond certification, GGI offers a range of educational programs, 
            including gemstone identification, diamond grading, and jewelry design
            courses. Our commitment to excellence and integrity has earned us a 
            reputation for providing accurate and honest assessments, making us 
            a trusted partner for both industry professionals and discerning consumers.

              </p>
              <div className="contentLeft"><br/>
                <h4 data-aos="fade-right">Our Vision </h4>
                <p data-aos="fade-left">
                To be the foremost authority in gemology, providing unparalleled expertise and knowledge.
                </p>
                <h4 data-aos="fade-up-right"><br/>
                Our Mission </h4>
                <p data-aos="fade-up-left">
                To elevate the industry by:
                </p>
                <p data-aos="fade-down-right">
                ⦁	Sharing knowledge and techniques to empower local manufacturers.<br/>
⦁	Promoting international standards in jewelry manufacturing.<br/>
⦁	Building consumer confidence through authentic identification and grading reports.<br/>
⦁	Continuously upgrading our laboratory and human resources.<br/>

                </p>
              </div>
            </div>
            <img
              alt="diamond"
              src={
                "https://res.cloudinary.com/ggi/image/upload/v1637903387/Blue-Diamonds-Buying-Guide_so4mja.webp"
              }
              data-aos="flip-left"
            />
          </div>
        </div>
      </div>
      <Sectionfive />
      <Sectiontwo />
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(About);
